import { render, staticRenderFns } from "./ArticleMovePopup.vue?vue&type=template&id=358fa7ef&"
import script from "./ArticleMovePopup.vue?vue&type=script&lang=ts&"
export * from "./ArticleMovePopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports